import { render, staticRenderFns } from "./signAdressDia.vue?vue&type=template&id=4457c331"
import script from "./signAdressDia.vue?vue&type=script&lang=js"
export * from "./signAdressDia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports